import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Container, Row, Col, Card, Alert, Button } from "react-bootstrap";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import OrgCheckoutForm from "./OrgCheckoutForm";

import axios from "axios";

import { config } from "../../common/Constants";

const stripePromise = loadStripe(config.stripePublishableKey);

const OrgCheckoutScreen = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [clientSecret, setClientSecret] = useState("");
    const [loading, setLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState("");
    
    const checkoutState = location.state || null;

    const username = checkoutState?.username;
    const password = checkoutState?.password;
    const isGroup = checkoutState?.isGroup;
    const ctFullName = checkoutState?.ctFullName;
    const ctPosition = checkoutState?.ctPosition;
    const ctPhone = checkoutState?.ctPhone;
    const ctEmail = checkoutState?.ctEmail;
    const orgName = checkoutState?.orgName;
    const orgAddress = checkoutState?.orgAddress;
    const orgSchools = checkoutState?.orgSchools;

    const hasRequiredState = Boolean(
        checkoutState &&
        username &&
        password &&
        ctFullName &&
        ctPosition &&
        ctPhone &&
        ctEmail &&
        orgName &&
        orgAddress
    );

    useEffect(() => {
        window.scrollTo(0, 0);

        const headerConfig = {
            header: {
              "Content-Type": "application/json",
            },
        };

        if ( !hasRequiredState ) {
            navigate("/org-register");
            return;
        }

        async function fetchData() {
            // Create PaymentIntent as soon as the page loads
            try {
                setLoading(true);
                setErrorMessage("");
                const response = await axios.post(`${config.apiBaseUrl}/payment/org-create-payment-intent`, {
                    username,
                    password,
                    isGroup,
                    ctFullName,
                    ctPosition,
                    ctPhone,
                    ctEmail,
                    orgName,
                    orgAddress,
                    orgSchools,
                }, headerConfig);
                setClientSecret(response.data.clientSecret);
            } catch (error) {
                const apiErrorMessage = error?.response?.data?.error;
                setErrorMessage(apiErrorMessage || "Unable to initialise checkout. Please return to registration and try again.");
            } finally {
                setLoading(false);
            }
        }

        fetchData();
    }, [username, password, isGroup, ctFullName, ctPosition, ctPhone, ctEmail, orgName, orgAddress, orgSchools, hasRequiredState, navigate]);
    
    const appearance = {
        theme: 'stripe',
    };
    const options = {
        clientSecret,
        appearance,
    };

    return (
        <Container className="page-shell">
            {loading && <p>Preparing secure checkout...</p>}

            {errorMessage && (
                <div className="page-section">
                    <Alert variant="danger" className="mb-3">
                        {errorMessage}
                    </Alert>
                    <Button variant="primary" onClick={() => navigate("/org-register")}>Back to Registration</Button>
                </div>
            )}

            {clientSecret && (
                <div className="page-section">
                    <section className="page-header">
                        <h3 className="page-title">Checkout</h3>
                        <p className="page-subtitle">Confirm organisation subscription details and complete payment.</p>
                    </section>
                    <Row>
                        <Col xs={12} md={6}>
                            <Card className="h-100">
                                <Card.Body>
                                    <h4>Course</h4>
                                    <p className="fw-bold mb-0">AclangEDGE Vocabulary to Discourse</p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col xs={12} md={6}>
                            <Card className="h-100">
                                <Card.Body>
                                    <h4>Price</h4>
                                    { isGroup ? <p className="fw-bold mb-0">$15000.00 AUD</p> : <p className="fw-bold mb-0">$9000.00 AUD</p> }
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    <p className="mt-4 mb-3">Please enter your payment method and click Pay to complete your purchase.</p>
                    <Elements options={options} stripe={stripePromise}>
                        <OrgCheckoutForm/>
                    </Elements>
                </div>
            )}
        </Container>
    );
}

export default OrgCheckoutScreen;